import React from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import { Transition } from 'react-transition-group';

const LazyAnimation = ({ children, duration = 1000, type, style = {} }) => {
  const defaultStyle = {
    transition: `all ${duration}ms ease-in-out`,
  };

  const transitionStyles = {
    entering: {},
    entered: {},
    exiting: {},
    exited: {},
  };

  if (type.includes('translate-top-20')) {
    defaultStyle.transform = 'translateY(20px)';
    transitionStyles.entering.transform = 'translateY(0)';
    transitionStyles.entered.transform = 'translateY(0)';
  } else if (type.includes('translate-bottom-80')) {
    defaultStyle.transform = 'translateY(-80px)';
    transitionStyles.entering.transform = 'translateY(0)';
    transitionStyles.entered.transform = 'translateY(0)';
  } else if (type.includes('translate-bottom-20')) {
    defaultStyle.transform = 'translateY(-20px)';
    transitionStyles.entering.transform = 'translateY(0)';
    transitionStyles.entered.transform = 'translateY(0)';
  }
  if (type.includes('fade-in')) {
    defaultStyle.opacity = 0;
    transitionStyles.entering.opacity = 1;
    transitionStyles.entered.opacity = 1;
  }
  if (type.includes('scale-up-0')) {
    defaultStyle.transform = `${defaultStyle.transform || ''} scale(0)`;
    transitionStyles.entering.transform = `${transitionStyles.entering
      .transform || ''} scale(1)`;
    transitionStyles.entered.transform = `${transitionStyles.entered
      .transform || ''} scale(1)`;
  } else if (type.includes('scale-up-80')) {
    defaultStyle.transform = `${defaultStyle.transform || ''} scale(0.8)`;
    transitionStyles.entering.transform = `${transitionStyles.entering
      .transform || ''} scale(1)`;
    transitionStyles.entered.transform = `${transitionStyles.entered
      .transform || ''} scale(1)`;
  }
  if (type.includes('translate-right-40')) {
    defaultStyle.transform = `${defaultStyle.transform ||
      ''} translateX(-40px)`;
    transitionStyles.entering.transform = `${transitionStyles.entering
      .transform || ''} translateX(0)`;
    transitionStyles.entered.transform = `${transitionStyles.entered
      .transform || ''} translateX(0)`;
  } else if (type.includes('translate-left-40')) {
    defaultStyle.transform = `${defaultStyle.transform || ''} translateX(40px)`;
    transitionStyles.entering.transform = `${transitionStyles.entering
      .transform || ''} translateX(0)`;
    transitionStyles.entered.transform = `${transitionStyles.entered
      .transform || ''} translateX(0)`;
  } else if (type.includes('translate-left-200')) {
    defaultStyle.transform = `${defaultStyle.transform ||
      ''} translateX(200px)`;
    transitionStyles.entering.transform = `${transitionStyles.entering
      .transform || ''} translateX(0)`;
    transitionStyles.entered.transform = `${transitionStyles.entered
      .transform || ''} translateX(0)`;
  } else if (type.includes('translate-right-200')) {
    defaultStyle.transform = `${defaultStyle.transform ||
      ''} translateX(-200px)`;
    transitionStyles.entering.transform = `${transitionStyles.entering
      .transform || ''} translateX(0)`;
    transitionStyles.entered.transform = `${transitionStyles.entered
      .transform || ''} translateX(0)`;
  }

  const [ref, inView] = useInView({
    rootMargin: '0px 0px',
    triggerOnce: true,
  });

  return (
    <Transition in={inView} timeout={duration}>
      {state => (
        <div
          ref={ref}
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
            ...style,
          }}
        >
          {children}
        </div>
      )}
    </Transition>
  );
};

LazyAnimation.propTypes = {
  children: PropTypes.node.isRequired,
  duration: PropTypes.number,
  type: PropTypes.string,
  style: PropTypes.object,
};

export default LazyAnimation;
